import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTableSelect from '@/components/datatable/DataTableSelect.vue';
    import type { DataTableSelectOption } from '@/types';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import { ref, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { AcceptableValue } from 'reka-ui';

    import type { Row } from '@tanstack/vue-table';
    import type { DashboardTableData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableReloadSelect',
  props: {
    modelValue: {},
    companyId: {},
    row: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const currentValue = ref(props.modelValue);

    // Keep local model in sync if outer data changes (e.g., details hydration or other edits)
    watch(
        () => props.modelValue,
        (val) => {
            currentValue.value = val as AcceptableValue;
        },
    );

    const options: DataTableSelectOption[] = [
        {
            value: 0,
            label: t('forms.no'),
            color: 'red',
        },
        {
            value: 1,
            label: t('forms.yes'),
            color: 'green',
        },
        {
            value: 2,
            label: t('forms.loading'),
            color: 'yellow',
        },
    ];

    const handleChange = async (newValue: AcceptableValue) => {
        const previousValue = currentValue.value;

        try {
            const selectedOption = options.find((opt) => opt.value === newValue);
            if (!selectedOption) return;

            currentValue.value = newValue;

            await axios.post(route('v2.dashboard.reload-on-demand.update'), {
                company_id: props.companyId,
                reload_on_demand: newValue,
            });

            // Persist change into the row so virtualized/unloaded rows keep the updated value
            if (props.row && props.row.original) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                (props.row.original as any).reload_on_demand = newValue as any;
            }

            emit('update:modelValue', newValue);
        } catch (error) {
            currentValue.value = previousValue;
            console.error('Failed to update status:', error);
            toast.error(t('dashboards.status_update_failed'));
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableSelect, {
    "model-value": currentValue.value,
    options: options,
    "onUpdate:modelValue": handleChange
  }, null, 8, ["model-value"]))
}
}

})